import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu",
  "use": "icon-menu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-menu\"><defs><style type=\"text/css\"></style></defs><path d=\"M96 128h832v192H96zM96 416h832v192H96zM96 704h832v192H96z\" p-id=\"2560\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol